import vClickOutside from "v-click-outside";

export default {
  inject: ["$validator"],

  props: {
    scope: { type: String },
    dropdownItems: { type: Array },
    dropdownParentIndex: { type: Number },
    dropdownIndex: { type: Number },
    placeholder: { type: String },
    onSelect: { type: Function },
    optionalyAvailable: { type: Boolean },
    selectedName: { type: String },
    isRequired: { type: Boolean },
    name: { type: String },
  },

  data() {
    return {
      selected: {
        name: "",
      },
      isOpen: false,
      items: [],
    };
  },

  watch: {
    dropdownItems: function (val) {
      this.items = val;
    },

    selectedName: function (val) {
      this.selected = val;
    },
  },

  methods: {
    toggleDropdown: toggleDropdown,
    closeDropdown: closeDropdown,
    pick: pick,
  },

  mounted() {
    this.items = this.dropdownItems === undefined ? [] : this.dropdownItems;
    this.selected = this.selectedName ? this.selectedName : "";
  },

  directives: {
    clickOutside: vClickOutside.directive,
  },
};

function pick(item) {
  this.selected = item;

  this.onSelect(item, this.name, this.dropdownIndex, this.dropdownParentIndex);
  this.closeDropdown();
}

function toggleDropdown() {
  if (this.items.length) {
    this.isOpen = !this.isOpen;
  }
}

function closeDropdown() {
  this.isOpen = false;
}
